export const normalLettersSpacing = {
    normal: "0",
    tight: "-0.025em",
    tighter: "-0.05em",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em"
}

export const hugeLettersSpacing = {
    normal: "0.3em",
    tight: "-0.025em",
    tighter: "-0.05em",
    wide: "0.05em",
    wider: "0.1em",
    widest: "0.2em"
}